import { gql } from 'graphql.macro'

export default gql`
  fragment TimestampFragment on Timestamp {
    id
    slug
    timestamp
  }
`
